import { render, staticRenderFns } from "./Informations.vue?vue&type=template&id=29afad61&scoped=true&"
import script from "./Informations.vue?vue&type=script&lang=js&"
export * from "./Informations.vue?vue&type=script&lang=js&"
import style0 from "./Informations.vue?vue&type=style&index=0&id=29afad61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29afad61",
  null
  
)

export default component.exports